module.exports = __webpack_public_path__ + "img/logo_roadme.d60632d8.png";